export default __webpack_public_path__ + "static/media/img_about6@2x.min.2ec8cf17.jpg";